module.exports = __webpack_public_path__ + "785d8bc4878ea2be3b47ba79d218aa03.svg";